import { POST } from '../_http';
import type { operations } from '@/types/schemas/calcs.main';
type controller = operations['SetupFeeRateController_calculate'];

export type SetupFeeRateBody = controller['requestBody']['content']['application/json'];
export type SetupFeeRateResponse = controller['responses']['200']['content']['application/json'];

export const setupFeeRate = POST('/formulas/setup-fee-rate')<SetupFeeRateBody, SetupFeeRateResponse>;
